export default __webpack_public_path__ + "static/media/plain-sticker-on.459b49ab.png";